/**
 * HUB-G — KPI timeline + périmètre M1 / M2.
 */
import React from 'react';
import { ACTIVITE_TIMELINE_OVERVIEW_LIMIT } from '../../utils/activite/activityTabs';
import { magasinScopeLabel } from '../../utils/activite/activityEvents';
import MagasinBadge from '../MagasinBadge';

export default function ActiviteTimelineKpiStrip({ kpis, magasinId, eventCount }) {
  const scope = magasinScopeLabel(magasinId);

  return (
    <div className="space-y-3" data-testid="activite-timeline-kpi">
      <div className="flex flex-wrap items-center gap-2">
        <span className="text-xs text-[var(--rm-gray-500)]">Périmètre :</span>
        {magasinId ? (
          <MagasinBadge code={magasinId} size="sm" />
        ) : (
          <span className="rm-badge rm-badge--muted" data-testid="activite-timeline-scope-all">{scope}</span>
        )}
        <span className="text-xs text-[var(--rm-gray-500)]">
          · {eventCount ?? 0} / {ACTIVITE_TIMELINE_OVERVIEW_LIMIT} événements
        </span>
      </div>

      {!magasinId && kpis && (
        <div className="grid grid-cols-2 gap-2 text-xs" data-testid="activite-timeline-kpi-magasin-breakdown">
          {['M1', 'M2'].map((code) => (
            <div
              key={code}
              className="rounded-lg border px-3 py-2"
              style={{ borderColor: 'var(--rm-border-subtle)', background: 'var(--rm-bg-panel)' }}
            >
              <MagasinBadge code={code} size="sm" />
              <span className="text-[var(--rm-gray-400)] ml-2">{kpis[code] ?? 0} événement(s)</span>
            </div>
          ))}
        </div>
      )}

      <div className="grid grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 gap-3 text-sm">
        <div className="rounded-xl border p-3" style={{ borderColor: 'var(--rm-border-subtle)', background: 'var(--rm-bg-panel)' }} data-testid="activite-kpi-timeline-ventes">
          <div className="text-xs text-[var(--rm-gray-500)]">Ventes</div>
          <div className="font-bold text-[var(--rm-success)]">{kpis?.vente ?? 0}</div>
        </div>
        <div className="rounded-xl border p-3" style={{ borderColor: 'var(--rm-border-subtle)', background: 'var(--rm-bg-panel)' }} data-testid="activite-kpi-timeline-paiements">
          <div className="text-xs text-[var(--rm-gray-500)]">Paiements</div>
          <div className="font-bold text-[var(--rm-white)]">{kpis?.paiement ?? 0}</div>
        </div>
        <div className="rounded-xl border p-3" style={{ borderColor: 'var(--rm-border-subtle)', background: 'var(--rm-bg-panel)' }} data-testid="activite-kpi-timeline-caisse">
          <div className="text-xs text-[var(--rm-gray-500)]">Caisse</div>
          <div className="font-bold text-[var(--rm-gray-200)]">{kpis?.caisse ?? 0}</div>
        </div>
        <div className="rounded-xl border p-3" style={{ borderColor: 'var(--rm-border-subtle)', background: 'var(--rm-bg-panel)' }} data-testid="activite-kpi-timeline-stock">
          <div className="text-xs text-[var(--rm-gray-500)]">Stock</div>
          <div className="font-bold text-[var(--rm-gray-200)]">{kpis?.stock ?? 0}</div>
        </div>
        <div className="rounded-xl border p-3" style={{ borderColor: 'var(--rm-border-subtle)', background: 'var(--rm-bg-panel)' }} data-testid="activite-kpi-timeline-reparations">
          <div className="text-xs text-[var(--rm-gray-500)]">Réparations</div>
          <div className="font-bold text-[var(--rm-white)]">{kpis?.reparation ?? 0}</div>
        </div>
        <div className="rounded-xl border p-3" style={{ borderColor: 'var(--rm-border-subtle)', background: 'var(--rm-bg-panel)' }} data-testid="activite-kpi-timeline-retraits">
          <div className="text-xs text-[var(--rm-gray-500)]">Retraits</div>
          <div className="font-bold text-[var(--rm-red-light)]">{kpis?.retrait ?? 0}</div>
        </div>
      </div>
    </div>
  );
}
